import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PagosService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/pagos', httpClient, authService);
  }

  /**
   * Registrar un abono a una venta
   * POST /api/v1/pagos/venta/:ventaId/abono
   */
  registrarAbono(ventaId: number | string, monto: number, metodoPago?: string): Observable<any> {
    return this.post({ monto, metodoPago }, `venta/${ventaId}/abono`);
  }

  /**
   * Obtener todos los pagos (abonos) de una venta
   * GET /api/v1/pagos/venta/:ventaId
   */
  obtenerPagosPorVenta(ventaId: number | string): Observable<any[]> {
    return this.get(`venta/${ventaId}`);
  }
}

